// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_1w1mt","page":"jEPge","isActive":"_124t9"};